import * as React from 'react';
import { CustomPicker } from 'react-color';
import { Hue, Saturation } from 'react-color/lib/components/common';
import { HueProps } from 'react-color/lib/components/common/Hue';
import { SaturationProps } from 'react-color/lib/components/common/Saturation';

import { Bem } from '../../service/Bem/Bem';

import './ColorPicker.css';

const BLOCK = 'color-picker';

export const ColorPicker = CustomPicker((props: HueProps & SaturationProps) => (
    <div className={BLOCK}>
        <div className={Bem.cls(BLOCK, 'saturation')}>
            <Saturation {...props} />
        </div>
        <div className={Bem.cls(BLOCK, 'hue')}>
            <Hue {...props} />
        </div>
    </div>
));
